// extracted by mini-css-extract-plugin
export var container = "Thoughts-module--container--b2d1b";
export var layout = "Thoughts-module--layout--06d5b";
export var subtitle = "Thoughts-module--subtitle--c0ec3";
export var content = "Thoughts-module--content--75585";